module.exports = __webpack_public_path__ + "img/kobenhavn-logo-icon.ba63e284.png";